import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AuthService } from '@common/services/AuthService/AuthService';
import { AuthGuardService } from '@common/services/AuthGuardService/AuthGuardService';
import { LoginGuardService } from '@common/services/LoginGuardService/LoginGuardService';
import { ModalService } from '@common/services/ModalService/ModalService';
import { TaskService } from '@common/services/TaskService/TaskService';
import { ClientService } from '@common/services/ClientService/ClientService';
import { EmployeeService } from '@common/services/EmployeeService/EmployeeService';
import { AreaService } from '@common/services/AreaService/AreaService';
import { ProgressService } from '@common/services/ProgressService/ProgressService';

@NgModule({
  imports: [
    HttpClientModule,
  ],
  providers: [
    AreaService,
    AuthService,
    AuthGuardService,
    LoginGuardService,
    ModalService,
    TaskService,
    ClientService,
    EmployeeService,
    ProgressService,
  ],
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/common/services/services.module.ts